import { render, staticRenderFns } from "./CompanySize.vue?vue&type=template&id=dd2fe054&"
import script from "./CompanySize.vue?vue&type=script&lang=js&"
export * from "./CompanySize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports